<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">Добавить город</h1>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'cities' }">← Назад к Городам</router-link>
    </div>

    <city-add-form @after="handleAfter" />

  </div>
</template>

<script>
import cityAddForm from '@/components/forms/city/CityAddForm'

export default {
  name: 'city-add',
  components: { cityAddForm },
  methods: {
    handleAfter (success) {
      if (success) {
        this.$router.push({ name: 'cities' })
      }
    },
    showMsg (msg, type, title) {
      this.$parent.showPopupMsg(msg, type, title)
    }
  }
}
</script>


// WEBPACK FOOTER //
// CityAdd.vue?68015802